export const DEFAULT_WORKSPACE_KEY = 'defaultWorkspace';
